import styled from 'styled-components';

export const ListSceneWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 2000;
  &:after {
    content: '';
    background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 1) 35%,
      transparent
    );
    opacity: 0;
    width: 400px;
    height: 100%;
    position: absolute;
    z-index: -1;
    display: block;
    top: 0;
    left: 0;
    pointer-events: none;
    transition: all 0.13s ease-out;
  }
  &.active {
    width: 400px;
    height: 100%;
    &:after {
      opacity: 1;
      z-index: 999;
    }
  }
  &.active {
    .gallery {
      left: 0;
      right: unset;
    }
    .galleryDots {
      opacity: 0;
    }
    .copyright {
      transform: translateY(100%);
    }
  }
  .closeBtn {
    position: fixed;
    right: 0;
    top: 0;
    color: #fff;
    font-size: 1.5rem;
    width: 2.5rem;
    height: 2.5rem;
    background: rgb(0 0 0 / 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    /* // pointer-events: none; */
    display: none;
    @media (max-width: 575px) {
      &.show {
        display: flex;
      }
      &.hide {
        display: none;
      }
    }
  }
  .galleryDots {
    transition: all 0.25s ease-out;
    align-items: center;
    flex-flow: column;
    position: absolute;
    width: 4px;
    height: 80%;
    display: flex;
    opacity: 1;
    padding-left: 15px;
    top: 10%;
    justify-content: center;
    span {
      height: 40px;
      width: 4px;
      margin: 2px 0;
      display: block;
      background: rgb(255 255 255 / 0.5);
      cursor: pointer;
      border-radius: 25px;
      transition: all 0.25s ease-out;
      &.active {
        background: #fff;
      }
    }
    @media (max-width: 575px) {
      width: 2.25rem;
      height: 2.5rem;
      background: #fff;
      box-shadow: 0 0 24px 0 rgb(0 0 0 / 0.5);
      top: 0;
      bottom: 0;
      margin: auto;
      padding: 0;
      font-size: 1.25rem;
      border-radius: 0 3px 3px 0;
      &:after {
        content: '\f0c9';
        font-family: 'Font Awesome 5 Pro';
        font-weight: 300;
      }
      span {
        /* height: 20px !important; */
        display: none;
      }
    }
  }
  .gallery {
    transition: 0.5s cubic-bezier(0.04, 1, 0.6, 0.97);
    position: absolute;
    width: 200px;
    top: 0;
    bottom: 0;
    left: -200px;
    z-index: 2001;
    padding-top: 12px;
    padding-bottom: 24px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
    .galleryGroup {
      padding: 0;
      width: 100%;
      height: auto;
      border-bottom: 1px solid rgb(255 255 255 / 0.2);
      .galleryGroupName {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        cursor: pointer;
        padding: 0.5rem 0.75rem;
        @media (hover: hover) and (pointer: fine) {
          &:hover {
            background: rgb(255 255 255 / 0.15);
            i {
              opacity: 1;
            }
          }
        }
        h5 {
          text-transform: uppercase;
          font-size: 13px;
          margin-bottom: 0;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          flex: 1;
          color: inherit;
        }
        i {
          font-size: 20px;
          opacity: 0.5;
        }
      }
      .galleryThumb {
        margin-bottom: 0.75rem;
        padding: 0 0.75rem;
        &.hide {
          height: 0;
          overflow: hidden;
          margin-bottom: 0;
          .galleryImg {
          }
        }
        .galleryImg {
          transition: 0.15s ease-out;
          width: 100%;
          height: 90px;
          margin: 0.5rem 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          position: relative;
          border: 1px solid rgba(255, 255, 255, 0.25);
          border-radius: 3px;
          /* transform: scale(.95); */
          cursor: pointer;
          @media (hover: hover) and (pointer: fine) {
            &:hover {
              border-color: #fff;
              transform: scale(1.05);
            }
          }
          &.active {
            border-color: var(--color-primary);
            box-shadow: 0 0 0 2px var(--color-primary);
          }
          img {
            width: 100%;
            min-height: 100%;
            object-fit: contain;
            background: rgba(0, 0, 0, 1);
          }
          .--menuSceneTitle {
            z-index: 10;
            position: absolute;
            bottom: 0;
            margin: 0;
            left: 0;
            right: 0;
            font-weight: inherit;
            font-size: inherit;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #fff;
            padding: 0.75rem 0.5rem 0.25rem;
            background-image: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.75),
              transparent
            );
          }
        }
      }
    }
  }
  @media (max-width: 575px) {
    z-index: 2000;
    &:after {
      width: 100%;
    }
    &.active {
      width: 100%;
    }
  }
`;

export const ControlbarWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: flex-end;
  @media (max-width: 575px) {
    flex-direction: column;
    align-items: center;
    .actGroup {
      padding-right: 0 !important;
    }
  }
  .copyright {
    pointer-events: auto;
    flex: 1;
    transition: all 0.25s ease-out;
    p {
      color: rgb(255 255 255 / 0.75);
      background-image: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.75),
        transparent
      );
      padding: 0.5rem 6rem 0.5rem 15px;
      display: inline-flex;
      a {
        font-weight: 500;
        color: #fff;
        margin-left: 0.25rem;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    @media (max-width: 575px) {
      position: absolute;
      bottom: 2.75rem;
      left: 0;
      p {
        padding: 0.125rem 4rem 0.125rem 0.75rem;
      }
    }
  }
  .actDirection {
    display: none;
    @media screen and (max-width: 1024px) {
      display: none;
    }
    .actDirectionWrapper {
      pointer-events: auto;
      /* transform: rotate(45deg) scale(0.7, 0.7); */
      transform: scale(0.7) translate(0, 2.5rem);
      transition: 0.5s cubic-bezier(0.04, 1, 0.6, 0.97);
      width: 80px;
      height: 86px;
      margin: 0.5rem 0;
      @media (max-width: 1024px) {
        transform: scale(0.9);
      }
      button {
        &.active {
          opacity: 1;
        }
        width: 24px;
        height: 38px;
        position: absolute;
        opacity: 0.5;
        transition: all 0.13s ease-out;
        padding: 0;
        background: transparent;
        border: none;
        span {
          width: 100%;
          height: 100%;
          display: block;
          background: #fff;
          // border: 2px solid #aaa;
          // border-style: outset;
          clip-path: polygon(50% 0, 100% 68%, 50% 100%, 0 68%);
          transition: all 0.13s ease-out;
        }
        @media (hover: hover) and (pointer: fine) {
          &:hover {
            opacity: 1;
          }
        }
        &:active span {
          transform: scale(0.7);
        }
        &:nth-child(1) {
          top: 0;
          bottom: initial;
          left: 0;
          right: 0;
          margin: auto;
        }
        &:nth-child(2) {
          top: 0;
          bottom: 0;
          left: initial;
          right: 0;
          margin: auto;
          transform: rotate(90deg);
        }
        &:nth-child(3) {
          top: initial;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          transform: rotate(180deg);
        }
        &:nth-child(4) {
          top: 0;
          bottom: 0;
          left: 0;
          right: initial;
          margin: auto;
          transform: rotate(270deg);
        }
      }
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          transform: scale(0.9) translateY(0.5rem);
        }
      }
    }
  }
  .actGroup {
    pointer-events: auto;
    justify-content: flex-end;
    padding: 0 0.5rem 0 2rem;
    // flex: 1;
    display: flex;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.75), transparent);
    border-radius: 12px 0 0 0;
    @media screen and (max-width: 575px) {
      background: transparent;
    }
    button {
      background: none;
      border: none;
      color: #fff;
      position: relative;
      padding: 0;
      margin: 0 2px;
    }
    .act {
      height: 34px;
      width: 2.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      text-shadow: 0 1px 3px rgb(0 0 0 / 0.75);
      transition: var(--transition-smooth);
      &:after {
        content: '';
        width: 100%;
        height: 100%;
        background: rgb(0 0 0 / 0.75);
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        z-index: -1;
        border-radius: 50%;
        opacity: 0;
        transition: all 0.13s ease-out;
        transform: scale(0.5);
      }
      @media (hover: hover) and (pointer: fine) {
        &:hover {
          text-shadow: 0 0 20px #fff;
          transform: scale(1.1);
          i {
            font-weight: 900;
          }
          &:after {
            // opacity: 0.75;
            // transform: scale(1);
          }
          i {
          }
        }
      }
    }
    i {
      font-size: 1.1rem;
    }
    img {
      width: 1.1rem;
    }
    .controlbar-item__img {
      width: auto;
      height: calc(100% - 8px);
      object-fit: contain;
      max-width: 100%;
    }
    .actPopGroup {
    }
    @media (max-width: 575px) {
      .act {
        i {
          font-size: 1.25rem;
        }
        img {
          width: 1.25rem;
        }
      }
    }
  }
`;

export const HeaderWrapper = styled.div`
  top: 0;
  left: 0;
  padding: 1rem 2.5rem 2.5rem;
  width: 100%;
  max-width: none;
  z-index: 2;
  transition: 0.5s cubic-bezier(0.04, 1, 0.6, 0.97);
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.25) 5%,
    transparent
  );
  position: absolute;
  pointer-events: none;
  &.showSidebar {
    margin-left: 190px;
    padding-left: 1.5rem;
    ~ div {
      .copyright {
        transform: translateX(-100%);
      }
    }
    @media (max-width: 575px) {
      &.showSidebar {
        margin-left: 0;
        ~ div {
          .copyright {
            transform: none;
          }
        }
      }
    }
  }

  display: flex;
  flex-direction: column;
  width: 100%;
  .--logo {
    padding: 0 0 12px;
    width: 100%;
    display: flex;
    cursor: pointer;
    &.topLeft {
      justify-content: flex-start;
    }
    &.topCenter {
      justify-content: center;
      position: absolute;
      left: 0;
    }
    &.topRight {
      justify-content: flex-end;
      position: absolute;
      left: 0;
      padding-right: 12px;
    }
    img {
      width: 100%;
      height: auto;
      pointer-events: auto;
      max-height: max-content;
    }
    @media (max-width: 575px) {
      position: relative !important;
      justify-content: initial !important;
      max-width: 45vw;
      padding: 0 0 12px 0 !important;
      img {
        max-width: 100%;
      }
    }
  }
  .--info {
    width: max-content;
    max-width: 100%;
    .--projectTitle {
      font-size: 20px;
      margin: 0px;
      color: #fff;
      font-weight: 700;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 25%);
      width: max-content;
      max-width: 100%;
    }
    .address {
      margin: -0.25rem 0 0.75rem 0;
      color: #fff;
      text-shadow: 0 2px 4px rgb(0 0 0 / 25%);
      font-weight: 500;
      width: max-content;
      max-width: 100%;
    }
    .popInfo {
      position: relative;
      pointer-events: auto;
      width: max-content;
      max-width: 100%;
      button {
        border: none;
        font-size: 0.8rem;
        font-weight: 700;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: max-content;
        padding: 0;
        display: flex;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 100px;
        padding: 2px 8px;
      }
      @media (max-width: 575px) {
        margin-top: 0;
        button {
          font-size: 0.875rem;
        }
      }
    }
    .popInfoToggle {
      color: #fff;
      text-shadow: 0 2px 4px rgb(0 0 0 / 25%);
      span {
        margin-left: 0.5rem;
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.25);
        animation: pulse-grow 1.5s infinite;
        animation-duration: 1500ms !important;
        border-radius: 50%;
      }
      i {
        width: 1.25rem;
        height: 1.25rem;
        background: rgb(0 0 0 / 0.25);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        font-size: 0.75rem;
      }
    }
    .popInfoArticle {
      p {
        margin-bottom: 1rem;
      }
    }
    .popInfoContent {
      background: #fff;
      box-shadow: 0 12px 24px rgb(0 0 0 / 0.5);
      width: 320px;
      padding: 0 0 1.5rem;
      opacity: 0;
      position: absolute;
      pointer-events: none;
      top: 0;
      left: 0;
      border-radius: 0;
      max-height: 420px;
      overflow: auto;
      transition: 0.5s cubic-bezier(0.04, 1, 0.6, 0.97);
      transform: translateX(-4rem);
      @media (max-width: 768px) {
        width: 70vw;
        max-width: 320px;
      }
      &::-webkit-scrollbar {
        display: none;
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
      &.active {
        opacity: 1;
        transform: translateX(0);
        pointer-events: auto;
      }
      .popInfoContentHead {
        position: sticky;
        top: 0;
        left: 0;
        right: 0;
        background: var(--color-primary);
        color: var(--color-text);
        padding: 0.75rem 1.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ececec;
        h4 {
          flex: 1;
          font-size: 20px;
          margin: 0;
          color: inherit;
        }
      }
      .popInfoArticle {
        padding: 0.5rem 1.5rem;
      }
      .popInfoClose {
        width: 1.5rem;
        height: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        cursor: pointer;
        @media (hover: hover) and (pointer: fine) {
          &:hover {
            background: rgb(0 0 0 / 0.2);
          }
        }
      }
      p {
        color: var(--color-text);
      }
    }
  }
  @media (max-width: 768px) {
  }

  @media (max-width: 575px) {
    padding: 0.75rem 0.75rem 2rem;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.75) 5%,
      transparent
    );
    h3 {
      font-size: 20px;
    }
    .address {
      display: none;
    }
    .popInfo {
      .popInfoContentHead {
        padding: 0.5rem 1.5rem;
        h4 {
          font-size: 18px;
        }
      }
    }
    .popInfoClose {
    }
  }
`;

export const ThemeDefaultWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #ffffff;
  button {
    cursor: pointer;
  }
`;

export const ControlbarPopoverWrapper = styled.div`
  z-index: 100;

  ul {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      button {
        cursor: pointer;
        background: #000;
        border-color: transparent;
        color: #fff;
        width: 100%;
        justify-content: left;
        height: auto;
        display: flex;
        align-items: center;
        transition: all 0.13s ease-out;
        @media (hover: hover) and (pointer: fine) {
          &:hover {
            color: #fff;
          }
        }
        img,
        i {
          width: 2rem;
          height: 2rem;
          color: #fff;
          margin-right: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          border-radius: 50%;
          // background: #393839;
          text-shadow: none;
          transition: all 0.13s ease-out;
        }
        img {
          padding: 0.1rem;
        }
        @media (hover: hover) and (pointer: fine) {
          &:hover {
            i,
            img {
              // background-color: #fff;
              // color: #212121;
              // transform: scale(0.8);
            }
          }
        }
      }
    }
  }
`;
